import axios from "@/libs/axios";
import APIS from '@/apis'

const ADMIN_TYPE = {
    '超管': 'R01&R02',
    '分管': 'R03&R04',
    '店铺': 'R05&R06'
}
const MESSAGE_TYPE = {
    '订单消息': '1',
    '订单消息-订单开票': '11',
    '订单消息-订单出库': '12',
    '订单消息-退款处理': '13',
    '订单消息-异常订单': '14',
    '客户消息': '2',
    '客户消息-资质认证': '21',
    '客户消息-开户申请': '22',
    '客户消息-资质更新': '23',
    '客户消息-客户同步': '24',
    '商品消息': '3',
    '商品消息-售卖申请': '31',
    '商品消息-新品申请': '32'
}

function checkUserType (userType) {
    let userTypeText
    Object.keys(ADMIN_TYPE).forEach(key => {
        if (ADMIN_TYPE[key].includes(userType)) {
            userTypeText = key
        }
    })
    return userTypeText
}
export async function getRoute (data, userInfo) {
    let { erpJointFlag, userType } = userInfo
    let userTypeText = checkUserType(userType)
    let bindData = data.bindData
    let routerPath = ''
    switch (String(data.messageNode)) {
        case MESSAGE_TYPE['订单消息-订单开票']:
            if (userTypeText === '分管') {
                routerPath = `/orderManage/orderDetails?${bindData}&purpose=LOOK`
            } else {
                if (erpJointFlag == 0) {
                    routerPath = await checkOrder('待审核', bindData)
                } else {
                    routerPath = `/orderManage/orderDetails?${bindData}&purpose=LOOK`
                }
            }
            break 
        case MESSAGE_TYPE['订单消息-订单出库']:
                if (userTypeText === '分管') {
                    routerPath = `/orderManage/orderDetails?${bindData}&purpose=LOOK`
                } else {
                    if (erpJointFlag == 0) {
                        routerPath = await checkOrder('待处理', bindData)
                    } else {
                        routerPath = `/orderManage/orderDetails?${bindData}&purpose=LOOK`
                    }
                }
                break 
        case MESSAGE_TYPE['订单消息-退款处理']:
            routerPath = '/orderManage/refundReview'
            break 
        case MESSAGE_TYPE['订单消息-异常订单']:
            routerPath = `/orderManage/orderDetails?${bindData}&purpose=LOOK`
            break
        case MESSAGE_TYPE['客户消息-资质认证']:
            if (userTypeText === '分管') {
                routerPath = await checkCustomerQualifie(bindData)
            } else {
                routerPath = '/noPermission'
            }
            break 
        case MESSAGE_TYPE['客户消息-开户申请']:
            if (userTypeText === '分管') {
                routerPath = '/noPermission' 
            } else {
                routerPath = await checkRelationsQualifie(bindData)
            }
            break
        case MESSAGE_TYPE['客户消息-资质更新']:
            if (userTypeText === '分管') {
                routerPath = await checkCustomerQuaUpdate(bindData)
            } else {
                routerPath = await checkRelationsQualifie(bindData)
            }
            break 
        case MESSAGE_TYPE['客户消息-客户同步']:
            routerPath = `/customerManage/erplist?${bindData}`
            break
        case MESSAGE_TYPE['商品消息-售卖申请']:
            if (userTypeText === '分管') {
                routerPath = '/goodsManage/commodityAudit'
            } else {
                routerPath = '/noPermission'
            }
            break
        case MESSAGE_TYPE['商品消息-新品申请']:
            if (userTypeText === '分管') {
                window.open('https://spzx.yun-sk.com/login.htm', '_blank')
            } else {
                routerPath = '/noPermission'
            }
            break
    }
    return routerPath
}

// 校验订单
async function checkOrder (statusStr, bindData) {
    let url = `${APIS.GET_ORDER_INFO}?${bindData}`
    let res = await axios.get(url)
    let { data } = res 
    let purpose = 'LOOK'
    if (statusStr === '待审核' && statusStr === data.orderStatusStr) {
        purpose = 'AUD'
    }
    if (statusStr === '待处理' && statusStr === data.orderStatusStr) {
        if (statusStr === data.orderStatusStr || data.orderStatusStr === '部分出库') {
            purpose = 'DELIVERY'
        }
    }
    if (data.intentionOrder == 1) {
        // 未建采
        purpose = 'LOOK'
    }
    return `/orderManage/orderDetails?${bindData}&purpose=${purpose}`
}
// 校验客户资质
async function checkCustomerQualifie (bindData) {
    let url = `${APIS.GET_APPLY_MESSAGE}?${bindData}`
    let res = await axios.get(url)
    let { success, ext } = res 
    if (success) {
        return `/customerManage/customerQualifie?${bindData}`
    }
    if (ext && ext.code === -1) {
        // 已经被审核了
        return `/customerManage/customerDetails?${bindData}`
    }
}
// 校验客户资质更新
async function checkCustomerQuaUpdate (bindData) {
    let url = `${APIS.GET_CHANGE_MESSAGE}?${bindData}`
    let res = await axios.get(url)
    let { success, ext } = res 
    if (success) {
        return `/customerManage/custQuaUpdate?${bindData}`
    }
    if (ext && ext.code === -1) {
        // 已经被审核了
        return `/customerManage/customerDetails?${bindData}`
    }
}
// 校验客户建采
async function checkRelationsQualifie (bindData) {
    let urlParam = urlParams(bindData)
    let params = {
        custId: urlParam.custId,
        relationId: urlParam.relationId,
        storeId: urlParam.storeId
    }
    let res = await axios.get(APIS.GET_CUST_MESSAGE, {params})
    let { data } = res 
    let detailCustRelationVo = data.detailCustRelationVo
    if (detailCustRelationVo == null || !detailCustRelationVo) {
        // 未审核
        return `/customerManage/relationsQualifie?${bindData}`
    }
    // 已审核
    let { buildRelation, applyStatus } = detailCustRelationVo
    if (buildRelation === '1') {
        // 已建采 更新待审核
        if (applyStatus === '1') {
            return `/customerManage/relationsUpdate?${bindData}`
        } 
        // 已建采
        return `/customerManage/relationsDetails?${bindData}`
    }
    if (buildRelation === '0') {
        // 未建采，待审核
        if (applyStatus === '0') return `/customerManage/relationsQualifie?${bindData}`
        // 其他状态，跳详情
        return `/customerManage/relationsDetails?${bindData}`
    }
    if (buildRelation === '2') {
        // 已解除
        if (applyStatus === '0') return `/customerManage/relationsQualifie?${bindData}`
        return `/customerManage/relationsDetails?${bindData}`
    }
}
// 校验客户建采更新
async function checkRelationsUpdate (bindData) {
    let urlParam = urlParams(bindData)
    let params = {
        custId: urlParam.custId,
        relationId: urlParam.relationId,
        storeId: urlParam.storeId
    }
    let res = await axios.get(APIS.GET_UPDATE_CUSTRELATION, {params})
    let { data } = res 
    let detailCustRelationVo = data.detailCustRelationVo
    if (detailCustRelationVo == null || !detailCustRelationVo) {
        // 未审核
        return `/customerManage/relationsQualifie?${bindData}`
    }
    // 已审核
    let { buildRelation, applyStatus } = detailCustRelationVo
    if (buildRelation === '1') {
        // 已建采
        return `/customerManage/relationsDetails?${bindData}`
    }
    if (buildRelation === '0') {
        // 未建采，待审核
        if (applyStatus === '0') return `/customerManage/relationsQualifie?${bindData}`
        // 其他状态，跳详情
        return `/customerManage/relationsDetails?${bindData}`
    }
}

function urlParams (urlString) {
    let params = {}
    let urlStringList = urlString.split('&')
    urlStringList.forEach(keyValue => {
        let keyValueList = keyValue.split('=')
        params[keyValueList[0]] = keyValueList[1]
    })
    return params
}


// WEBPACK FOOTER //
// ./src/components/notice/config.js